import { StepCheckOperatorType } from '../../../components/pages/Book/MemoryBank/memoryBankTypes';

export enum HubOptionStateValue {
  Active = 'active',
  Hidden = 'hidden',
  Disabled = 'disabled',
}

export enum ConditionQuantifier {
  All = 'all',
  Any = 'any',
}

/**
 * Narrowed operator type — only the 6 comparison operators valid for hub conditions.
 * StepCheckOperatorType also contains Min, Max, ConditionList, PlayerHas which are NOT valid here.
 */
export type HubConditionOperator =
  | StepCheckOperatorType.Equal
  | StepCheckOperatorType.NotEqual
  | StepCheckOperatorType.Greater
  | StepCheckOperatorType.AtLeast
  | StepCheckOperatorType.Less
  | StepCheckOperatorType.AtMost;

export type SubCondition = {
  uuid: string;
  variableId: number | null;
  operator: HubConditionOperator;
  /**
   * Right-hand value. Exactly one of intValue or varValue must be set when variableId is non-null.
   * intValue: raw string from the number input (e.g. "5", "-3")
   * varValue: memory variable ID (> 0; 0 = not set)
   */
  intValue?: string;
  varValue?: number;
};

export type StateCondition = {
  uuid: string;
  quantifier: ConditionQuantifier;
  subConditions: SubCondition[];
  resultState: HubOptionStateValue;
  /** Only relevant when resultState === 'disabled' */
  disabledText?: string;
};

export const HUB_MAX_STATE_CONDITIONS = 5;
export const HUB_MAX_SUB_CONDITIONS = 10;
